<template>
  <div class="tw-flex tw-flex-col tw-gap-3">
    <div
      v-for="detail in details"
      :key="detail.title"
      class="tw-flex tw-flex-col tw-gap-3"
    >
      <div class="sf-font-bold sf-font-m">{{ detail.title }}</div>
      <div
        v-for="{ key, content, type } in parseDescription(detail.description)"
        :key="key"
        class="tw-flex tw-flex-row"
      >
        <div
          v-if="type === 'markup'"
          v-dompurify-html="content"
          class="sf-font-s"
          style="position: relative; overflow: hidden"
        />
        <sf-math-formula v-else :content="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfMathFormula from '@app/shared/vue/components/sf-math-formula'
import type { parsedDescription } from '../types'
import { Detail } from '@app/shared/types/sf-data'

interface Props {
  details: Detail[]
}
defineProps<Props>()

function parseDescription(description: string): parsedDescription[] {
  const descriptionSections = description.split(/(\$\$[^$]*\$\$)/g)

  return descriptionSections.map((section, index) => {
    if (section.includes('$$')) {
      return {
        type: 'math',
        content: section.replace(/\$\$/g, ''),
        key: `math-${index}`,
      }
    } else {
      return {
        type: 'markup',
        content: section,
        key: `markup-${index}`,
      }
    }
  })
}
</script>
